/* eslint no-underscore-dangle: ["error", { "allow": ["_root"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import InlineSVG from 'svg-inline-react';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import ContactCard from '../ContactCard/ContactCard';
import IconProjectOpen from '../../assets/ic-project-open.svg';
import IconProjectClosed from '../../assets/ic-project-closed.svg';
import IconProjectCancelled from '../../assets/ic-project-cancelled.svg';

import classes from './ProjectTable.scss';

const renderCell = data => {
  let children = '';

  if (data.value._root.entries[3][1] !== 0) {
    children = ` (${data.value._root.entries[3][1]} Unterprojekte)`;
  }

  return (
    <Link to={`/project/${data.value._root.entries[1][1]}`}>
      {data.value._root.entries[0][1]}
      {children}
    </Link>
  );
};

const renderResponsible = data => (
  <ContactCard
    name={data.value._root.entries[1][1] ? data.value._root.entries[1][1] : ''}
    id={data.value._root.entries[0][1]}
    avatar={data.value._root.entries[2][1]}
    type="staff"
    displayType="small"
  />
);

const renderStatus = data => {
  const statusTooltipId = `project_${data.value._root.entries[0][1]}_status_tooltip`;
  let status = <span />;
  if (data.value._root.entries[1][1] === 'open') {
    status = (
      <InlineSVG
        src={IconProjectOpen}
        className={classes.projectStatusIcon}
        data-tip="offen"
        data-for={statusTooltipId}
      />
    );
  } else if (data.value._root.entries[1][1] === 'closed') {
    status = (
      <InlineSVG
        src={IconProjectClosed}
        className={classes.projectStatusIcon}
        data-tip="abgeschlossen"
        data-for={statusTooltipId}
      />
    );
  } else if (data.value._root.entries[1][1] === 'cancelled') {
    status = (
      <InlineSVG
        src={IconProjectCancelled}
        className={classes.projectStatusIcon}
        data-tip="abgebrochen"
        data-for={statusTooltipId}
      />
    );
  }

  return (
    <span>
      {status}
      <ReactTooltip
        id={statusTooltipId}
        className={classes.tooltip}
        place="top"
        type="dark"
        effect="solid"
      />
    </span>
  );
};

const components = {
  NoResults: () => (
    <div>
      <p className="text-center">
        <small>Keine Projekte eingetragen.</small>
      </p>
    </div>
  ),
};

const prepareData = (dataArray, staffs) => {
  const newData = [];
  dataArray.forEach(data => {
    // create new object that will be handled by griddle
    let leader = {};

    if (typeof staffs !== 'undefined') {
      const tempLeader = _.find(staffs, ['id', data.project_leader]);
      if (typeof tempLeader !== 'undefined') {
        leader = tempLeader;
      } else {
        leader = { name: '-gelöscht-' };
      }
    }

    let end = '';
    if (typeof data.end !== 'undefined' && data.end !== null) {
      end = moment(data.end).format('DD.MM.YYYY');
    }

    newData.push({
      id: data.id,
      number: data.project_number,
      title: data.name,
      name: leader.name,
      link: {
        title: data.name,
        id: data.id,
        status: data.status,
        children: data.childrenCount,
      },
      responsible: {
        id: leader.id,
        name: leader.name,
        avatar: leader.avatar,
        type: 'staff',
      },
      start: moment(data.start).format('DD.MM.YYYY'),
      end,
      status: {
        id: data.id,
        status: data.status,
      },
    });
  });
  return newData;
};

const ProjectTable = props => (
  <Griddle
    data={prepareData(props.projects, props.staffs)}
    plugins={[plugins.LocalPlugin]}
    components={components}
    pageProperties={{
      pageSize: 20,
    }}
  >
    <RowDefinition keyColumn="id">
      <ColumnDefinition
        id="id"
        title="ID"
        cssClassName="text-right"
        visible={false}
      />
      <ColumnDefinition id="number" title="PNR" />
      <ColumnDefinition id="link" title="Titel" customComponent={renderCell} />
      <ColumnDefinition
        id="responsible"
        title="Leiter"
        customComponent={renderResponsible}
      />
      <ColumnDefinition id="start" title="Start" />
      <ColumnDefinition id="end" title="Ende" />
      <ColumnDefinition
        id="status"
        title="Status"
        className="text-center"
        customComponent={renderStatus}
      />
    </RowDefinition>
  </Griddle>
);

ProjectTable.propTypes = {
  projects: PropTypes.array.isRequired,
  staffs: PropTypes.array,
};

export default ProjectTable;



// WEBPACK FOOTER //
// ./src/components/ProjectTable/ProjectTable.js